// extracted by mini-css-extract-plugin
export default {"root":"styles_root__gbeLg","body":"styles_body__0vjNu","logo":"styles_logo__QisND","form":"styles_form__tV9WT"};